import * as Yup from 'yup';

// validates models/form-values.ts

export const validationSchema = Yup.object().shape({
    items: Yup.array().of(
        Yup.object().shape({
            offer: Yup.object().shape({
                deliveryPrice: Yup.number()
                    .required('app.common.errors.required')
                    .typeError('app.common.errors.required')
                    .min(0, 'app.common.errors.positive'),
                surcharge: Yup.number().required('app.common.errors.required').typeError('app.common.errors.required'),
                offerItems: Yup.array().of(
                    Yup.object().shape({
                        isSelected: Yup.boolean(),
                        isAlternative: Yup.boolean(),
                        /*
                         * Missing, not a number, or zero — for the supplier
                         * it is the same situation and it has one answer:
                         * name a price or take the position out. "Pflichtfeld"
                         * said nothing about the way out (#2239 R-140).
                         */
                        price: Yup.mixed().when('isSelected', {
                            is: true,
                            then: Yup.number()
                                .required('app.offers.errors.priceOrDeselect')
                                .typeError('app.offers.errors.priceOrDeselect')
                                .moreThan(0, 'app.offers.errors.priceOrDeselect'),
                        }),
                        alternativeNote: Yup.string().when(['isAlternative', 'isSelected'], {
                            is: true,
                            then: Yup.string().required('app.common.errors.required'),
                        }),
                    })
                ),
            }),
        })
    ),
    termsOfPayment: Yup.string().required('app.common.errors.required'),
    termsOfDelivery: Yup.string().required('app.common.errors.required'),
    supplierBonus: Yup.string().required('app.common.errors.required'),
});
